import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import 'animate.css';
import App from './App';
import { store } from './redux/store';
import ThemedApp from './ThemedApp';

const browserHistory = createBrowserHistory();

ReactDOM.render(
  <Provider store={store}>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <ThemedApp>
        <Router history={browserHistory}>
          <App />
        </Router>
      </ThemedApp>
    </MuiPickersUtilsProvider>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.register();
